import * as _ from 'underscore';
import { ServiceLocator } from '../../../app/ServiceLocator';
import { WebClientListResourceFetcher } from '../../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { SiteRolesResource } from './SiteRoles';
import { ListResult } from '../../../ts/fetchers/ListResult';
import { Filter } from '../../../ts/helpers/Filter';
import { RequestHelper } from '../../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../../httpClient/utils/ResultHelper';
import { SliceableHelper } from '../../../ts/helpers/SliceableHelper';
import { Module } from '../../../ts/Module';
import {
  CheckUserNamesRequest,
  ICheckUserNamesResult,
} from '../../../ts/ServerApi/requests/CheckUserNamesRequest';
import { GetUsersRequest, IGetUsersResult } from '../../../ts/ServerApi/requests/GetUsersRequest';
import { FilterFieldNames, IStringArrayValuedFieldFilterClause } from '../../../ts/ServerApi/types/IFilterClause';
import { SiteRoles } from '../../../ts/ServerApi/types/ISiteRole';
import { IUser } from '../../../ts/ServerApi/types/IUser';
import { FetcherFactory } from '../../../ts/services/FetcherFactory';
import { Resource } from '../../../ts/resources/Resource';
import WebHttpClient from '../../../httpClient/WebHttpClient';

export class Users extends Resource<IUser> {

  public static readonly instance = new Users(new WebClientListResourceFetcher(GetUsersRequest, (result: IGetUsersResult) => result.users));

  public checkUserNames(usernames: string[]): ng.IPromise<ICheckUserNamesResult> {
    return WebHttpClient.sendRequests(
      RequestHelper.buildRequests(usernames,
        (usernamesBlock) => new CheckUserNamesRequest({ usernames: usernamesBlock })),
      (results: ICheckUserNamesResult[]) => {
        return {
          errors: ResultHelper.combineErrors(results),
          users: ResultHelper.combine(results, (result) => result.users)
        };
      });
  }

  public getUsersById(userIds: string[]): ng.IPromise<ListResult<IUser>> {
    return SliceableHelper.fetchAll(this.all()
      .addFilter(Filter.stringFieldInArray('id', userIds)));
  }

  // gets the user with the specified username & domainName.
  public getUserByUsernameAndDomain(username: string, domainName: string): ng.IPromise<any> {
    return this.all()
      .addFilter(Filter.stringFieldEq('username', username))
      .addFilter(Filter.stringFieldEq('domainName', domainName))
      .getFirst();
  }

  public getAdminsOnlyFilter(): IStringArrayValuedFieldFilterClause{
   return Filter.stringFieldInArray(FilterFieldNames.siteRole, SiteRolesResource.instance.getAdminRoles());
  }

  public getCanOwnProjectFilter(): IStringArrayValuedFieldFilterClause {
    return Filter.stringFieldInArray(FilterFieldNames.siteRole, SiteRolesResource.instance.getProjectOwnershipRoles());
  }

  public getWithoutGuestFilter(): IStringArrayValuedFieldFilterClause {
    return Filter.stringFieldInArray(FilterFieldNames.siteRole,
    _.without(SiteRolesResource.instance.allOptions(), SiteRoles.Guest, SiteRoles.Unlicensed));
  }

}

export default Users.instance;
